module.exports = __webpack_public_path__ + "img/wifi-fill.9b664dcd.svg";